import { render, staticRenderFns } from "./main-lawyer.vue?vue&type=template&id=425e589c&scoped=true"
import script from "./main-lawyer.vue?vue&type=script&lang=js"
export * from "./main-lawyer.vue?vue&type=script&lang=js"
import style0 from "./main-lawyer.vue?vue&type=style&index=0&id=425e589c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425e589c",
  null
  
)

export default component.exports